import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function CreateNewDataSource(props) {
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceName, setDataSourceName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceName('')
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDataSourceName(props.taskData.dataSourceName)
            setDatabaseName(props.taskData.databaseName)
        }
    }, [])

    useEffect(() => {
        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDataSourceName(props.taskData.dataSourceName)
            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceName('')
        }
    }, [props.taskData.databaseId,props.taskData.dataSourceName])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceName('')
        setDatabaseName('')

        sqLDbList.forEach(db => {
            if (db.id === event.target.value) {
                setDatabaseName(db.dBname)
                fireOnSaveEvent(event.target.value, db.dBname, "")
            }  
        })
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsName - Data source name
     */
    function fireOnSaveEvent(dbId, dbName, dsName) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceName"] = dsName
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Create New Data Source</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={false}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Data Source Name"
                    variant="outlined"
                    value={dataSourceName}
                    disabled={false}
                    onChange={(e) => {
                        e.preventDefault()
                        setDataSourceName(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, e.target.value)
                    }} />
            </FormControl>
        </Paper>
    )
}

export default CreateNewDataSource